module.exports = __webpack_public_path__ + "static/media/heads.76e77302.png";